import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useRouting } from '../../hooks/useRouting';
const handlesOwnNavigation = (props, event) => event.defaultPrevented ||
    event.button !== 0 ||
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey ||
    event.altKey ||
    !!props.download ||
    (!!props.target && props.target !== '_self');
export const Link = (props) => {
    const [_, navigate] = useRouting();
    return (_jsx("a", Object.assign({}, props, { onClick: e => {
            var _a, _b;
            if (handlesOwnNavigation(props, e)) {
                (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
            else {
                e.preventDefault();
                if (props.onClick)
                    props.onClick(e);
                else
                    navigate((_b = e.currentTarget.getAttribute('href')) !== null && _b !== void 0 ? _b : '');
            }
        } })));
};
export default Link;
